var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.518,19.5l-7.748,7.748l-1.768-1.768l4.73-4.73H0.75v-2.5h25.982l-4.73-4.73l1.768-1.768L31.518,19.5z  M6.283,12.5l1.064-1.606L8.402,12.5h1.685L8.168,9.771l1.758-2.456H8.314L7.348,8.74L6.43,7.314H4.755l1.792,2.515L4.677,12.5 H6.283z M10.751,13.53l0.269,0.566c0.293-0.104,0.535-0.248,0.725-0.43c0.191-0.182,0.32-0.388,0.389-0.618s0.103-0.543,0.103-0.94 v-0.981h-1.372V12.5h0.664c-0.007,0.277-0.068,0.495-0.186,0.654S11.027,13.439,10.751,13.53z M14.647,13.23 c-0.153,0.187-0.389,0.281-0.708,0.281c-0.173,0-0.366-0.021-0.581-0.063l0.122,1.074c0.254,0.055,0.513,0.083,0.776,0.083 c0.261,0,0.494-0.028,0.701-0.083c0.206-0.055,0.381-0.133,0.521-0.232c0.143-0.099,0.268-0.229,0.377-0.388 c0.108-0.16,0.224-0.391,0.344-0.693l0.327-0.903l1.831-4.99h-1.421l-1.211,3.682l-1.24-3.682h-1.46l1.973,5.2 C14.918,12.804,14.801,13.043,14.647,13.23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoto);
export default __webpack_public_path__ + "static/media/goto.ac1ea11837f5d703e457969d04459230.svg";
export { ForwardRef as ReactComponent };